/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Remove_Set_TitleInputs */



/**
* | output |
* | --- |
* | "Remove Set" |
*
* @param {Tags_Manager_Remove_Set_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_remove_set_title = /** @type {((inputs?: Tags_Manager_Remove_Set_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Remove_Set_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer l'ensemble")
	if (locale === "de") return /** @type {LocalizedString} */ ("Entfernen Sie den Satz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi set")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить набор")
	if (locale === "es") return /** @type {LocalizedString} */ ("Quitar conjunto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移除设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セットを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेट हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover conjunto")
	return /** @type {LocalizedString} */ ("Remove Set")
});